import { mapValues } from 'lodash';
import type { OptionsStanza } from './AST';
import { ColumnarData, DataFrame } from './DataFrame';
import { DataFrameLite } from './DataFrameLite';
import EncodingExecutor from './EncodingExecutor';
import type { Frames } from './EncodingExecutor';

export class Options {
    /**
     * Takes the options stanza and the dataSources, and returns a simple properties object. Any options
     * that were expressions are evaluated. The resulting object is suitable to pass to a pure viz as props.
     * @param {OptionsStanza} options
     * @param dataSources
     * @param themeFunc
     * @param dataFramesIn
     * @param bypassCloneDeepOptionScope
     * @param lazyLoadingDataFrame
     * @param enableTagSearchResult If true, tag DataPoints from datasource with isSearchResult (UDF is the only team currently using this flag for identifying if input values are coming from search)
     * @returns {object}
     */
    static evaluate(
        options: OptionsStanza,
        dataSources: { [key: string]: ColumnarData },
        themeFunc?: (themeKey) => any,
        dataFramesIn?: Frames,
        bypassCloneDeepOptionScope?: boolean,
        lazyLoadingDataFrame?: boolean,
        enableTagSearchResult?: boolean
    ) {
        let dataFrames: Frames;
        if (dataFramesIn) {
            dataFrames = dataFramesIn;
        } else {
            dataFrames = Options.dataFrameFromDataSource(
                dataSources,
                lazyLoadingDataFrame,
                enableTagSearchResult
            );
        }
        return new EncodingExecutor().executeOptions(
            options,
            dataFrames,
            themeFunc,
            bypassCloneDeepOptionScope
        );
    }

    static dataFrameFromDataSource(
        dataSources: { [key: string]: ColumnarData },
        lazyLoadingDataFrame?: boolean,
        enableTagSearchResult?: boolean
    ): Frames {
        if (lazyLoadingDataFrame) {
            return mapValues(dataSources, ds => DataFrameLite.fromJsonCols(ds, enableTagSearchResult));
        }
        return mapValues(dataSources, ds => DataFrame.fromJsonCols(ds, enableTagSearchResult));
    }
}
